// ═══════════════════════════════════════════════════════════════
// DonorDetailView — Custom Fields Section
// Path: src/components/donorDetail/CustomFieldsSection.jsx
//
// Extracted from DonorDetailView.jsx during modularization Phase 3.
// Renders dynamic custom fields (text, number, date, checkbox, dropdown).
//
// Props-only — does not call useApp() directly.
// ═══════════════════════════════════════════════════════════════

import React from "react";
import { FONT_SIZES, FONT_FAMILY } from "../../constants/appConfig";

// ═══════════════════════════════════════════════════════════════
// CustomFieldsContent
// ═══════════════════════════════════════════════════════════════

export const CustomFieldsContent = ({
  customFields,
  detailForm,
  updateField,
  updateMember,
  selectedMember,
  palette,
}) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
    {customFields.map((cf) => {
      const fieldKey = `custom_${cf.id}`;
      const value = detailForm[fieldKey];
      if (cf.type === "checkbox") {
        return (
          <label
            key={cf.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: FONT_SIZES.sm,
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={value || false}
              onChange={(e) => {
                updateField(fieldKey, e.target.checked);
                updateMember(
                  selectedMember.id,
                  { [fieldKey]: e.target.checked },
                  true
                );
              }}
            />
            {cf.label}
          </label>
        );
      }
      if (cf.type === "dropdown") {
        return (
          <div
            key={cf.id}
            style={{ display: "flex", flexDirection: "column", gap: 4 }}
          >
            <span
              style={{
                fontSize: FONT_SIZES.xs,
                fontWeight: 600,
                color: palette.text2,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              {cf.label}
            </span>
            <select
              value={value || ""}
              onChange={(e) => {
                updateField(fieldKey, e.target.value);
                updateMember(
                  selectedMember.id,
                  { [fieldKey]: e.target.value },
                  true
                );
              }}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                fontSize: FONT_SIZES.sm,
                fontFamily: FONT_FAMILY,
                border: `1px solid ${palette.inputBorder}`,
                background: palette.inputBg,
                color: palette.inputColor,
                outline: "none",
              }}
            >
              <option value="">Select...</option>
              {(cf.options || []).map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        );
      }
      return (
        <div
          key={cf.id}
          style={{ display: "flex", flexDirection: "column", gap: 4 }}
        >
          <span
            style={{
              fontSize: FONT_SIZES.xs,
              fontWeight: 600,
              color: palette.text2,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {cf.label}
          </span>
          <input
            type={
              cf.type === "number"
                ? "number"
                : cf.type === "date"
                ? "date"
                : "text"
            }
            value={value || ""}
            onChange={(e) =>
              updateField(
                fieldKey,
                cf.type === "number"
                  ? e.target.value
                    ? Number(e.target.value)
                    : ""
                  : e.target.value
              )
            }
            onBlur={() =>
              updateMember(
                selectedMember.id,
                { [fieldKey]: detailForm[fieldKey] },
                true
              )
            }
            placeholder={cf.label}
            style={{
              padding: "8px 12px",
              borderRadius: 8,
              fontSize: FONT_SIZES.sm,
              fontFamily: FONT_FAMILY,
              border: `1px solid ${palette.inputBorder}`,
              background: palette.inputBg,
              color: palette.inputColor,
              outline: "none",
            }}
          />
        </div>
      );
    })}
  </div>
);
